import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const GreenCheckIcon = (props) => {
	return <CheckCircleIcon style={{ color: 'green' }} {...props} />;
};

export default GreenCheckIcon;
